import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  Error,
  ModelAsset
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  children?: (respone: ModelAsset[]) => ReactElement
  onError?: (error: Error) => void
  onSuccess?: (respone: ModelAsset[]) => void
}

const GetAiModelAssetsRequest = ({
  id,
  children,
  onError,
  onSuccess
}: Props) => {
  const url = `${AI_API_SERVICE}/models/${id}/assets`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetAiModelAssetsRequest
